import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CurrentConfigService } from './cms/current-config.service';
import { ThemeService } from './@services/theme.service';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '@if (isLoaded) {<router-outlet></router-outlet>}',
})
export class AppComponent implements OnInit {
  isDarkMode = false;
  isCollapsed = false;
  isLoaded = true;

  constructor(
    public translate: TranslateService,
    private currentConfigService: CurrentConfigService,
    private router: Router,
    private themeService: ThemeService,
  ) {
    translate.use(localStorage.getItem('lang') ?? 'en');
  }

  ngOnInit(): void {
    this.themeService.updateTheme();
    this.loadConfiguration();
  }

  async loadConfiguration() {
    try {
      const currentConfig = await this.currentConfigService.getConfig();
      const apiKey = currentConfig.currentConfiguration.adminPanelAPIKey;
      if (apiKey != null && apiKey !== '') {
        await this.loadScript(
          `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=drawing,places&callback=initMap`,
        );
      }
    } catch (e) {
      console.error('Error loading configuration', e);
    }
  }

  loadScript(name: string) {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = name;
      (window as unknown as any).initMap = (ev: any) => {
        resolve();
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
}
